<template>
  <div>
    <users-search
      class="mb-2"
      @users-selection="onUserSelection"
    />

    <hot-table
      ref="handsontable"
      :settings="hotSettings"
    >
      <hot-column
        title="Phone Number"
        read-only="true"
      />
      <hot-column
        title="First Name"
        read-only="true"
      />
      <hot-column
        title="Last Name"
        read-only="true"
      />
      <hot-column
        title="External ID"
        read-only="true"
      />
      <hot-column
        title="Reference ID"
        read-only="true"
      />
      <hot-column
        title="Reference Type"
        read-only="true"
      />
    </hot-table>
  </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { ref, onMounted } from '@vue/composition-api'
import UsersSearch from '@/views/users/rider/components/UsersSearch.vue'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    UsersSearch,

    HotTable,
    HotColumn,
  },
  props: {
    selectedUsers: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const handsontable = ref()
    const users = ref([])
    registerAllModules()
    const hotSettings = {
      height: 'auto',
      colWidths: [150, 150, 150, 150, 150],
      licenseKey: 'non-commercial-and-evaluation',
      contextMenu: ['remove_row'],
      afterRemoveRow: ix => {
        users.value.splice(ix, 1)
        ctx.emit('users-selection', users.value)
      },
    }

    const onUserSelection = user => {
      const isIncluded = users.value.find(u => u.phoneNumber === user.phoneNumber)
      if (isIncluded) {
        errorNotification('Already in the list')
        return
      }
      users.value.push(user)
      const tableData = users.value.map(usr => [usr.phoneNumber, usr?.firstName, usr?.lastName, usr?.externalId, usr?.referenceId, usr?.referenceType])
      handsontable.value.hotInstance.loadData(tableData)
      ctx.emit('users-selection', users.value)
    }
    onMounted(() => {
      if (props.selectedUsers.length) {
        users.value = [...props.selectedUsers]
        const tableData = users.value.map(usr => [usr.phoneNumber, usr?.firstName, usr?.lastName, usr?.externalId, usr?.referenceId, usr?.referenceType])
        handsontable.value.hotInstance.loadData(tableData)
      }
    })
    return {
      handsontable,
      hotSettings,
      onUserSelection,
    }
  },
}
</script>
